import { FILTER_TYPE } from '@/components/FilterPage/constants'

export default {
  setFeaturedArticles: (state, articles) => (state.featuredArticles = articles),

  setTopBanner: (state, banner) => (state.topBanner = banner),

  setBasePath: (state, url) => (state.basePath = url.replace(/\/?$/, '/')), // add trailling slash

  setIsStickyMenuMounted: (state, status) => (state.isStickyMenuMounted = status),

  setStickyMenuComponent: (state, component) => (state.stickyMenuComponent = component),

  setProducts: (state, products) => (state.products = products),

  setPromoCards: (state, promoCards) => (state.promoCards = promoCards),

  setFilters: (state, filters) => (state.filters = filters),

  clearActiveFilters: state => (state.activeFilters = []),

  clearActiveSecondaryFilters: state =>
    (state.activeFilters = state.activeFilters.filter(
      filter => filter.order !== FILTER_TYPE.SECONDARY
    )),

  setActiveSort: (state, sort) => (state.activeSort = sort),

  setSubPages: (state, pages) => (state.subPages = pages),

  setHasExplodedVariants: (state, status) => (state.hasExplodedVariants = status),

  setHasArticlesPageBottom: (state, status) => (state.hasArticlesPageBottom = status),

  setPageInfo: (state, info) => (state.pageInfo = { ...state.pageInfo, ...info }),

  setStartCursor: (state, cursor) => (state.pageInfo.startCursor = cursor),

  setFiltersFetched: (state, status) => (state.isFiltersFetched = status),

  setProductsFetched: (state, status) => (state.areProductsFetched = status),

  setFetchingMoreProducts: (state, status) => (state.isFetchingMoreProducts = status),

  setPromoCardsFetched: (state, status) => (state.isPromoCardsFetched = status),

  setSubPagesFetched: (state, status) => (state.isSubPagesFetched = status),

  setDataFetched: (state, status) => (state.isDataFetched = status),

  setUpdatedByFilter: (state, status) => (state.isUpdatedByFilter = status),

  setPromoCardsPositions: (state, windowWidth) => {
    /**
     * The results are hardcoded because they never change for a given window width.
     * They are an items/row estimation based on CSS styles.
     *
     * Rules:
     * - Small screens: 1 item at every 3rd position
     * - Bigger screens:
     *   - IF HAS even number of items/row: 1 item at the end of every other row
     *   - ELSE: 1 item at the beginning of every other row
     */
    let positions = [3, 6, 9, 12, 15]

    if (windowWidth > 3200) positions = [13, 21, 41, 49, 69]
    else if (windowWidth > 2600) positions = [11, 18, 35, 42, 59]
    else if (windowWidth > 2200) positions = [9, 15, 29, 35, 49]
    else if (windowWidth > 1770) positions = [7, 12, 23, 28, 39]
    else if (windowWidth > 1280) positions = [5, 9, 17, 21, 29]
    else if (windowWidth > 1000) positions = [3, 6, 11, 14, 19]
    else if (windowWidth > 800) positions = [3, 6, 9, 12, 15]
    else if (windowWidth > 700) positions = [3, 6, 11, 14, 19]

    state.promoPositions = positions
  },

  // Activate a list of filters || increment active values
  setActiveFilters(state, newFilters) {
    if (newFilters.length === 0) return

    if (state.activeFilters.length === 0) {
      // no previous filter, just set
      state.activeFilters = newFilters
      return
    }

    newFilters.forEach(newFilter => {
      const activeIndex = state.activeFilters.findIndex(active => active.id === newFilter.id)
      if (activeIndex > -1) {
        // filter already active
        const activeFilterValues = state.activeFilters[activeIndex].values
        const newFilterValues = newFilter.values
        if (!activeFilterValues.some(activeValue => newFilterValues.includes(activeValue))) {
          // value NOT already active
          if (state.activeFilters[activeIndex].order === FILTER_TYPE.PRIMARY) {
            // is primary filter
            // - can have only 1 value
            state.activeFilters[activeIndex].values = newFilter.values
            // - may impact on secondary filters
          } else {
            // add value
            state.activeFilters[activeIndex].values.push(...newFilter.values)
          }
        }
      } else {
        // new filter
        state.activeFilters.push(newFilter)
      }
    })
  },

  // Remove one value from one filter || remove the filter
  removeActiveFilterValue(state, oldFilter) {
    if (state.activeFilters.length === 0) return // silence is golden

    if (oldFilter.order === FILTER_TYPE.PRIMARY) {
      // remove the whole filter since primaries can only have 1 value
      state.activeFilters = state.activeFilters.filter(filter => filter.id !== oldFilter.id)
    } else {
      state.activeFilters = state.activeFilters.reduce((activeFilters, filter) => {
        // not the same filter, no changes
        if (filter.id !== oldFilter.id) return [...activeFilters, filter]

        // filter values for the same filter
        filter.values = filter.values.filter(value => value !== oldFilter.value)

        // no more values left ? remove filter : updated filter
        return filter.values.length === 0 ? activeFilters : [...activeFilters, filter]
      }, [])
    }
  },

  // active primary filters also filters the active secondary filters
  syncActiveFilters(state, visibleFilters) {
    state.activeFilters = state.activeFilters.filter(active => {
      if (active.order !== FILTER_TYPE.SECONDARY) return true
      return visibleFilters.some(visible => visible.id === active.id)
    })
  },
}
